module.exports = {
  language: {
    name: '中文'
  },
  login:{
    userNameInputError:"请输入您的账号",
    passwordInputError:"请输入您的密码",
    userNameError:'用户名不存在',
    passwordError:'密码错误,请重新输入',
    forbidden:"此账户已被禁用"
  },
  top:{
    myOrder:'我的订单',
    accountDetails:'账户详情',
    changePassword:'修改密码',
    newPassword:'新密码',
    newPassword1:'请输入您的新密码',
    confirmPassword:'确认密码',
    confirmPassword1:'请再次输入密码',
    logOut:'退出登录',
    logOutTips:"确认退出登录吗?",
    passwordTip:'密码可由大小写字母、数字组合，最少8位字符，最多16位',
    updatePwd:'新旧密码一致',
    updatePwd1:'旧密码验证失败',
    resetPassword:"重置密码",
    valPhoneTips:"请输入手机号",
    valPhoneTips1:"请输入正确的手机号",
    valPhoneTips2:"该手机号未注册",

  },
  user: {
    logTitle:'在线订单系统',
    logTitle1:'系统后台管理平台',
    login:'登录',
    userInfo:'账户信息',
    editAccountInfor:'编辑账户信息',
    register:'注册',
    loginUsername:'请输入邮箱/手机号',
    placeholder:'请输入您的账号/手机号',
    placeholder1:'请输入您的密码',
    rememberPassword:'记住密码',
    forgotPassword:'忘记密码',
    regUser:'还未注册账号',
    createAccount:'创建账户',
  },
  register:{
    registration:'新用户注册',
    existingAccount:'已有账户',
    LoginNow:'立即登录',
    userName:'用户名',
    userName1:'请输入您的用户名',
    phone:'手机号',
    phone1:'请输入您的手机号',
    fullName:'姓名',
    fullName1:'请输入您的姓名',
    sendCode:'发送验证码',
    inputCode:'请输入验证码',
    codeError:"验证码错误",
    unitName:'单位名称',
    unitName1:'请输入您的单位名称',
    password:'密码',
    password1:'请输入您的密码',
    password2:"两次输入密码不一致",
    initPassword:'原密码',
    initPassword1:'请输入您原来的密码',
    confirmPassword:'确认密码',
    confirmPassword1:'请再次输入您的密码',
    email:'邮箱',
    email1:'请输入您的邮箱',
    registerSuccess:"注册成功",
    registerError:"注册失败,用户名已存在",
    registerError1:"注册失败,该手机号已注册",
    registerError2:"禁止输入手机号为用户名",
  },
  order:{
    orderId:'订单编号',
    orderId1:'请输入订单编号',
    orderCreated:'下单时间',
    orderType:'订单类型',
    orderStatus:'订单状态',
    designName:'设计名称',
    designName1:'请输入设计名称',
    designCategory:'设计类型',
    query:'查询',
    resetting:'重置',
    operate:'操作',
    details:'详情',
    cancellationOrder:'取消订单'
  },
  orderDetail:{
    orderDetailLabel:"订单详情",
    orderingInformation:"订单信息",
    siteInformation:"位点信息",
    ReceivingInformation:"收货信息",
    designResults:"设计结果",
    manufacturerRemarks:"厂家备注",
  },
  product: {
    ngName:'NGSure™个性化低频变异检测方案',
    ngName1:'NGSure™个性化',
    ngName2:'低频变异检测方案',
    auName:'Augury™ 个性化 NGS panel',
    ngContent:'NGSure™可作为NGS检测后低丰度位点的验证方法，也适用于液体活检等低频变异场景的直接检测。客户可以选择检测服务或检测试剂盒两种产品形式。',
    auContent:'Augury™旨在提供针对各种基因组标志物的高灵敏度定制化检测解决方案。借助核心算法和专利技术，我们可以设计覆盖全部外显子或热点区域、针对CNV、Indel、SNV等在内的NGS Panel。',
    customizedProducts:'定制化产品',
    cp:"",
    cp1:"",
    customizedProducts1:'通过输入基因组上的任意位点从头设计NGSure™的引物探针。',
    customizedProducts2:'可提供单个或多个变异位点的具体信息，也可以只提供基因组坐标。',
    customizeNow:'立即定制',
    catalogProducts:'目录产品',
    catalogProducts1:'从已有的设计库中直接选择感兴趣的产品，以获得更短的定制周期。这些位点可能已通过质控标准品或实际样本测试，具有已知的最低检测下限（LoD）。其中部分产品可直接进行检测或提供现货试剂盒',
    queryNow:'立即查询',
    productAdvantages:'产品优势',
    productAdvantages1:'为什么选择使用我们的产品？',
    highSense:'高灵敏度',
    highSense1:'根据检测平台的不同，NGSure的最低检测限可达0.1%~0.01% ',
    highSense2:'进行初步定量，结合NGS可进行准确定量',
    comprehensiveAndFast:'全面快速',
    comprehensiveAndFast1:'可检测SNV、Indel等多种突变，简单快速完成定制化',
    comprehensiveAndFast2:'兼容多种样本类型，如FFPE、新鲜组织样本、血液等',
    platformFlexibility:'平台灵活',
    platformFlexibility1:'直接对接Sanger，让一代测序实现前所未有的灵敏度',
    platformFlexibility2:'结合探针法qPCR实现多重检测，实验流程更快捷、灵敏度更高',
    technicalCorePrinciples:'技术核心原理',
    technicalCorePrinciples1:'观看视频帮你更加了解我们的技术核心原理',
    technicalCorePrinciples2:'抑制探针置换扩增（Blocker Displacement Amplification, BDA）技术在 PCR 过程中选择性抑制野生型 DNA 序列的扩增，因此变异序列的富集效率相比前者提高了 1000 倍以上，使得常规技术（比如 Sanger 测序）检测低频突变成为可能。',
    clickToPlayTheVideo:'点击播放视频',
    frequentlyAskedQuestion:'常见问题',
    frequentlyAskedQuestion1:'在这里可以全面看到设计服务内容，了解如何使用它们',
    collapse1:'有哪几种交付方式？',
    collapse1Content:'',
    collapse2:'一份试剂盒包括什么？',
    collapse2Content:'',
    collapse3:'最小 DNA 起始量（input）要求？',
    collapse3Content:'',
    collapse4:'PCR 时长要求？',
    collapse4Content:'',
    collapse5:'一个试剂盒可以检测多少突变？',
    collapse5Content:'',
    collapse6:'可以检测哪些类型的突变？',
    collapse6Content:'',
    collapse7:'有什么设备要求？',
    collapse7Content:'',
    collapse8:'Sanger 测序对于低 VAF 的突变检测存在困难，你们如何保证 NGSure™ 平台的数据可靠？',
    collapse8Content:'',
    startYourCustomDesign:'开始你的定制设计',
    auIndex1:'依托阅尔基因独有的 SADDLE 算法和 QASeq 技术， Augury™ 定制化平台旨在提供针对各种基因组标志物的高灵敏度检测方案，适用于肿瘤液体活检、生殖遗传检测、感染性疾病检测、药物开发等多个领域。',
    excellentMultiplePerformance:'卓越的多重性能',
    excellentMultiplePerformance1:'Augury™ 能够设计出超过 1000 个扩增子的 NGS panel。',
    cnvHighPrecisionQuantification:'CNV高精度定量',
    cnvHighPrecisionQuantification1:'CNV 检测灵敏度可达 5%（等效倍性 = 2.05/1.95），适用于肿瘤液体活检。',
    multipleBiomarkerCoExamination:'多种标志物共检',
    multipleBiomarkerCoExamination1:'可同时高灵敏度地检测 CNV、SNV、indel、基因融合等变异类型。',
    flexibleSampleTypes:'灵活的样本类型',
    flexibleSampleTypes1:'可用于检测 cfDNA、FFPE 等，能够检测肿瘤细胞含量小于 10% 的组织样本。',
    newDAndClinicalTrials:'新药研发和临床试验',
    newDAndClinicalTrials1:'助力临床前的靶点发现、生物标志物以及替代临床终点研究，依托 CLIA / CAP 双认证实验室开展深入合作。',
    qASeq:'QASeq 技术能以较低的样本投入量对拷贝数变异和突变同时进行超灵敏检测。通过独有的引物设计算法SADDLE 抑制多重 PCR 反应中引物二聚体的形成，QASeq 能够覆盖更广泛的目标区域，从而提高定量准确性。',
    applicationCases:'应用案例',
    applicationCases1:'实际应用案例详解，仅供案例参考',
    augury:'AUGURY™乳腺癌 NGS PANEL 的开发和验证',
    auguryContent:'利用Augury™平台构建超灵敏 NGS panel，检测和量化 18 个乳腺癌相关基因的拷贝数变异和 14 个基因的热点突变。',
    detail:'查看详情',
    catalogProductList:'目录产品列表',
    geneSymbol:'基因',
    geneSymbol1:'请输入基因名',
    variantDescribe:'变异',
    variantDescribe1:'请输入变异名',
    sangerPlatform:'Sanger 平台',
    qpcrPlatform:'QPCR 平台',
    place:'订购',
  },
  createOrder:{
    designServices:'设计服务',
    designSContent:"使用一代测序平台对经过BDA放大后的突变序列进行检测",
    designSContent1:"结合探针法qPCR和BDA技术，使用实时荧光定量PCR仪器检测已知突变位点，理论上具有更低检测下限",
    designSContent2:"若点位中包含需要检测拷贝数变异的区域请勾选QASeq-CNV",
    productType:'产品类型',
    productType1:'请选择产品类型',
    Kit:"试剂盒",
    KitWEVerification:"试剂盒+验证",
    testingService:"检测服务",
    addressLabel:'收货地址',
    consigneeLabel:'收货人',
    consigneePhoneLabel:'联系电话',
    address:'请输入收货人地址',
    consignee:'请输入收货人姓名',
    consigneePhone:'请输入收货人手机号',
    saveDefaultAddress:"保存为默认收货地址",
    submit:'提交订单',
    productName:"产品名称",
    orderType:"订单类型",
    orderTypeContent1:"定制生产",
    orderTypeContent2:"目录产品(非现货)",
    orderTypeContent3:"目录产品(现货)",
    designName:"设计名称",
    designName1:"请输入设计名称",
    sampleType:"样本类型",
    sampleType1:"gDNA-FFPE(FFPE、甲醛固定组织)",
    sampleType1Tips:"该类样本的gDNA中可能存在损伤突变且平均长度更短",
    sampleType2:"cfDNA(血浆、脑脊液等)",
    sampleType3:"gDNA(组织、PBMC、唾液、精液等)",
    orderDescription:"订单说明",
    orderDescription1:"请输入订单说明信息，例如：突变位点检测下限（LoD）要求、样品类型细节等等。",
    orderDescription2:"请输入订单说明信息，例如：测序平台、检测下限（LoD）要求、疾病类型、DNA样本起始量等等。",
    back:"上一步",
    next:"下一步",
    optionDesignServer:"请选择设计服务",
    optionSampleType:"请选择样本类型",
    targets:'检测位点',
    targets1:"请输入检测位点",
    manualEntry:"手工录入",
    fileUpload:"文件上传",
    downloadTemplate:"下载模板",
    clickUpload:"点击上传",
    templateExample:"模板示例",
    targetsDesc:"检测位点格式说明",
    lookAll:"查看全部",
    OrderSubmitted:"订单已提交",
    OrderSubmitted1:"后台业务人员会尽快和您联系。从“我的订单列表” 可随时查看订单处理进度。",
    nextOrder:"再下一单",
    myOrderList:"我的订单列表",
  },
  orderStatusDict:{
    orderStatus1:"订单已提交",
    orderStatus2:"设计",
    orderStatus3:"生产",
    orderStatus4:"检测",
    orderStatus5:"交付",
    orderStatus6:"已关闭",
  },
  orderStatusDictList:{
    orderStatus1:"订单已提交",
    orderStatus2:"设计中",
    orderStatus3:"设计完成",
    orderStatus4:"设计异常",
    orderStatus5:"生产中",
    orderStatus6:"生产完成",
    orderStatus7:"检测中",
    orderStatus8:"检测完成",
    orderStatus9:"已关闭",
    orderStatus10:"待交付",
    orderStatus11:"已交付",
  },
  index:{
    welcome:'欢迎使用',
    yueer:'阅尔在线产品定制服务',
    about:'关于阅尔'
  },
  footer:{
    yeerGene:'阅尔基因',
    aboutUs:'关于我们',
    officialWebsite:"官方网站",
    productsServices:'产品和服务',
    technicalSupport:'技术支持',
    contactUs:'联系我们',
    law:'法律',
    privacyPolicy:'隐私政策',
    supplementaryTermsConditions:'补充条款和条件'
  },
  operate:{
    edit:'编辑',
    save:'保存',
    cancel:'取消',
    determine:'确定',
    updateSuccess:'修改成功',
    pleaseSelect:"请选择",
    startDate:"开始日期",
    endDate:"结束日期",
    cancelOrderContent:"请确认是否取消该订单?",
    cancelOrderTip:"订单已取消",
    copyOrder:"复制订单",
    tips:"提示",
    copyOrderTip:"订单已复制,是否跳转到创建订单页面?",
    backList:"返回列表",
    backPage:'返回',
    resetPasswordTips:"密码修改成功，请确认跳转到登录页，重新登录",
    resetPasswordTips1:"请确认退出重新登录",
  },
  loading:{
    loadingText:"数据加载中..."
  },
  title:{
    label:"阅尔基因在线产品定制服务平台",
  },
  targetsErrorTip:{
    rows:"检测位点第 ",
    label:"行格式错误",
    labelO:"一行只能输入一个位点",
    geneError:"基因名称错误",
    geneError1:"请输入基因名称",
    chromosomeError:"染色体名称错误",
    locationError:"位点坐标错误",
    wildTypeSequenceError:"野生型序列错误",
    mutationSequenceError:"突变序列错误",
    error1:"格式错误",
    error2:"位点",
    error3:"错误"
  }
}



// WEBPACK FOOTER //
// ./src/language/zh.js